import { can, type Capability } from './permissions';
import { useRole } from './context';

export function useCan(cap: Capability): boolean {
  return can(useRole(), cap);
}
